import { Box, Chip, Skeleton, Typography } from "@mui/material";

export const SummaryInfo = ({ icon, title, value }: { icon: React.ReactNode; title: string; value: string }) => {
  return (
    <Box sx={styles.serviceDetailsContainer}>
      <Typography sx={styles.serviceDetailsTitle}>
        {icon}
        {title}
      </Typography>
      <Typography sx={styles.serviceDetailsValue}>{value}</Typography>
    </Box>
  );
};

export const SummaryInfoWithChips = ({
  icon,
  title,
  firstItemName,
  totalLength,
}: {
  icon: React.ReactNode;
  title: string;
  firstItemName: string;
  totalLength: number;
}) => {
  return (
    <Box sx={styles.serviceDetailsContainer}>
      <Typography sx={styles.serviceDetailsTitle}>
        {icon}
        {title}
      </Typography>
      <Box sx={{ display: "flex", gap: "8px" }}>
        {firstItemName && <Chip title={firstItemName} label={firstItemName} sx={styles.serviceDetailsChip} />}
        {totalLength && totalLength > 1 && (
          <Chip title={`+${totalLength - 1}`} label={`+${totalLength - 1}`} sx={styles.serviceDetailsChip} />
        )}
      </Box>
    </Box>
  );
};

export const SummaryInfoWithLoader = ({ icon, title }: { icon: React.ReactNode; title: string }) => {
  return (
    <Box sx={styles.serviceDetailsContainer}>
      <Box sx={styles.serviceDetailsTitle}>
        <Skeleton variant="circular" width={24} height={24} />
        <Skeleton variant="rounded" width="100px" height={20} />
      </Box>
      <Skeleton variant="rounded" width="40px" height={20} />
    </Box>
  );
};

export const styles = {
  serviceDetailsContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  serviceDetailsTitle: {
    color: "var(--Gray-900, #1D2026)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "150%",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  serviceDetailsValue: {
    color: "var(--Gray-600, #6E7485)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "150%",
  },
  serviceDetailsChip: {
    color: "var(--Green---100, #008B07)",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    padding: "4px 12px",
    borderRadius: "16px",
    background: "var(--Green---25, #E7EFED)",
    maxWidth: "60px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    "& .MuiChip-label": {
      padding: "0",
    },
  },
} as const;
